import { render, staticRenderFns } from "./side-nav.vue?vue&type=template&id=b318beb8&scoped=true"
import script from "./side-nav.vue?vue&type=script&lang=js"
export * from "./side-nav.vue?vue&type=script&lang=js"
import style0 from "./side-nav.vue?vue&type=style&index=0&id=b318beb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b318beb8",
  null
  
)

export default component.exports